import React from 'react';
import Image from 'next/image';

export default function Logo() {
  return (
    <div className="king-site-logo">
      <a href="/">
        <Image
          src="https://css.brilliantearth.com/static/img/logo-new.svg"
          width={324}
          height={16.77}
          className="img-responsive center-block"
          role="img"
          alt="Brilliant earth Logo"
        />
      </a>
    </div>
  );
}
